// Action to set loading state
export const setLoading = (isLoading) => ({
    type: 'SET_LOADING',
    payload: isLoading,
});